import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

interface AdSlotProps {
  className?: string;
}

/** Emplacement publicitaire AdSense — à configurer avec un data-ad-slot une fois l'unité créée. */
export function AdSlot({ className }: AdSlotProps) {
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    pushed.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      /* AdSense non chargé ou bloqué */
    }
  }, []);

  return (
    <div className={className ?? 'ad-slot-wrap'}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-3964040172117553"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
